import PublicLayout from "@/components/layout/PublicLayout";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    intro: "La presente informativa descrive le modalità di trattamento dei dati personali degli utenti che consultano il portale Quattro Accommodations.",
    sections: [
      ["Titolare del trattamento", "Quattro Accommodations è il titolare del trattamento dei dati raccolti tramite il presente sito."],
      ["Dati raccolti", "Raccogliamo i dati forniti volontariamente tramite i moduli di contatto (nome, email, telefono, città, messaggio) e i dati di navigazione tecnici."],
      ["Finalità", "I dati sono trattati per rispondere alle richieste di preventivo, gestire la relazione commerciale e adempiere agli obblighi di legge."],
      ["Base giuridica", "Il trattamento si fonda sul consenso dell'interessato e sull'esecuzione di misure precontrattuali."],
      ["Conservazione", "I dati sono conservati per il tempo strettamente necessario alle finalità indicate e secondo gli obblighi normativi."],
      ["Diritti dell'interessato", "L'utente può esercitare i diritti di accesso, rettifica, cancellazione, limitazione e portabilità scrivendo a info@quattro.house."],
      ["Booking engine", "Le prenotazioni sono gestite dal booking engine della singola struttura; i relativi dati sono trattati dal titolare del booking engine."],
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    intro: "Il portale utilizza cookie tecnici e, previo consenso, cookie analitici per migliorare l'esperienza di navigazione.",
    sections: [
      ["Cookie tecnici", "Necessari al funzionamento del sito; non richiedono consenso."],
      ["Cookie analitici", "Utilizzati in forma aggregata per analizzare l'uso del sito (es. Google Analytics 4), previo consenso."],
      ["Cookie di terze parti", "Alcuni servizi integrati (mappe, booking engine) possono installare propri cookie."],
      ["Gestione dei cookie", "L'utente può gestire le preferenze tramite le impostazioni del browser o il banner di consenso."],
    ],
  },
  "termini-e-condizioni": {
    title: "Termini e Condizioni",
    intro: "L'utilizzo del portale Quattro Accommodations implica l'accettazione dei presenti termini e condizioni.",
    sections: [
      ["Ruolo di Quattro", "Quattro Accommodations favorisce la prenotazione diretta tra ospite e proprietario e non agisce come intermediario nella transazione."],
      ["Prenotazioni", "Le prenotazioni avvengono direttamente con la struttura tramite il relativo booking engine; condizioni e pagamenti sono regolati dalla struttura."],
      ["Contenuti", "I contenuti delle schede sono forniti in collaborazione con i proprietari; Quattro si impegna a mantenerli aggiornati."],
      ["Responsabilità", "Quattro non è responsabile per la disponibilità, i prezzi o le condizioni applicate dalle singole strutture."],
      ["Modifiche", "Quattro si riserva il diritto di modificare i presenti termini in qualsiasi momento."],
    ],
  },
};

export default function LegalPage({ page }) {
  const data = CONTENT[page];
  if (!data) return null;
  return (
    <PublicLayout>
      <section className="bg-brand-plum text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
          <h1 className="text-4xl sm:text-5xl font-serif">{data.title}</h1>
        </div>
      </section>
      <section className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <p className="text-lg text-brand-plum/70 leading-relaxed mb-10">{data.intro}</p>
        <div className="space-y-8">
          {data.sections.map(([title, body]) => (
            <div key={title}>
              <h2 className="font-serif text-2xl text-brand-plum mb-2">{title}</h2>
              <p className="text-brand-plum/70 leading-relaxed">{body}</p>
            </div>
          ))}
        </div>
        <p className="mt-12 text-sm text-brand-plum/40">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>
      </section>
    </PublicLayout>
  );
}
